import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const SplitPdfView = lazy(() => import("@/features/split-pdf/view"));

export const Route = createFileRoute("/split")({
  head: () =>
    pageMeta({
      title: "Split PDF",
      description:
        "Pull out a custom range of pages, or chop a PDF into fixed-size chunks. The original stays untouched.",
      path: "/split",
      keywords: "split pdf, separate pdf, extract pages, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <SplitPdfView />
    </Suspense>
  ),
});
